// extracted by mini-css-extract-plugin
export default {"wrapper":"Percentage_wrapper__BM370","percentageBar":"Percentage_percentageBar__3biwf","bar-animation":"Percentage_bar-animation__7zT3C"};